import script from "./AdminTestimonies.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminTestimonies.vue?vue&type=script&setup=true&lang=js"

import "./AdminTestimonies.vue?vue&type=style&index=0&id=0ba8dc14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ba8dc14"]])

export default __exports__